export default {"src":"/_next/static/media/icon-curiosity.1028589f.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};